import type { LeanCustomsInvoice } from "../services/leancustomsService";
import { pickString } from "./leanCustomsRecordUtils";

function parseMoney(v: unknown): number | null {
  if (v == null) return null;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string") {
    const cleaned = v
      .replace(/EUR|€/gi, "")
      .replace(/\s/g, "")
      .replace(",", ".");
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

function formatEur(amount: number): string {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
}

/** Sum invoice_amount (or similar) across declaration invoices. */
export function formatDeclarationInvoiceTotals(
  invoices: LeanCustomsInvoice[]
): string | null {
  if (invoices.length === 0) return null;

  let sum = 0;
  let found = false;
  let currency = "EUR";

  for (const inv of invoices) {
    const rec = inv as Record<string, unknown>;
    const amount =
      parseMoney(rec.invoice_amount) ??
      parseMoney(rec.total_amount) ??
      parseMoney(rec.amount);
    if (amount != null) {
      sum += amount;
      found = true;
      currency = pickString(rec.invoice_currency, rec.currency) ?? currency;
    }
  }

  if (!found) return null;
  if (currency.toUpperCase() === "EUR") return formatEur(sum);
  return `${sum.toFixed(2)} ${currency}`;
}
